import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './requesters';
import { TAG_TYPES } from 'types';

export const baseApi = createApi({
  baseQuery: axiosBaseQuery,
  tagTypes: Object.values(TAG_TYPES),
  endpoints: () => ({}),
  keepUnusedDataFor: 300, // 5 minutes in seconds
});
